import styled from "styled-components";

export const StatesViewToggle = styled.div`
  display: flex;
  position: absolute;
  z-index: 3;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;

  button:first-child {
    margin-right: 10px;
  }

  @media (min-width: 640px) {
    top: 18px;
    bottom: auto;
    left: 195px;
    width: auto;

    button:first-child {
      margin-right: 20px;
    }
  }
`;

export const MapSearchAutosuggest = styled.div`
  width: 100%;
`;